<template>
  <div style="margin: 10px">
    <v-form>
      <v-card>
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px"
            >{{ $t(formName) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm12 md6>
              <div style="padding: 0px 10px">
                <p class="font-weight-bold">
                  Số phiếu nhập kho: {{ importWh != null ? importWh.importNumber : '' }}
                </p>
                <p class="font-weight-bold">
                  Số thông báo: {{ importRequestNumber }}
                </p>
                <p class="font-weight-bold">
                  Mã kho: {{ warehouseCode }}
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md6>
              <p class="font-weight-bold">
                Ngày giao hàng: {{ importWh != null ? this.dateFormat(importWh.dateArrived) : '' }}
              </p>
              <p class="font-weight-bold">
                Người giao hàng: {{ importWh != null ? importWh.deliveryPerson : '' }}
              </p>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <table class="lstTable">
                <tr>
                  <th width="10%">{{ $t('lang.material.materialType') }}</th>
                  <th width="10%">Tên vật tư</th>
                  <th width="5%">Đơn vị</th>
                  <th width="10%">Đóng gói</th>
                  <th width="10%">Số lượng dự kiến giao</th>
                  <th>Thực nhập</th>
                  <th v-if="showImportTotal">Thực nhập lũy kế</th>
                  <th>Nhà cung cấp</th>
                  <th width="10%">Hạn sử dụng</th>
                  <th width="10%" v-if="showColKst">KST đánh giá</th>
                  <th width="10%" v-if="showColBgd">BGĐ đánh giá</th>
                </tr>
                <template v-for="(item, index) in lstMaterial">
                  <tr v-if="item.row === 0" :key="index">
                    <td style="font-weight: bold">{{ item.typeName }}</td>
                    <td colspan="7">Không có vật tư</td>
                  </tr>
                  <tr v-else :key="index">
                    <td :rowspan="item.row" v-if="item.row != undefined && item.row > 0" style="font-weight: bold">{{ item.typeName }}
                    </td>
                    <td>{{ item.materialName }}</td>
                    <td style="text-align: center">{{ item.unit }}</td>
                    <td style="text-align: center">{{ item.pack }}</td>
                    <td style="text-align: center">{{ item.orderQuantity | currency }}</td>
                    <td style="text-align: center">
                      <c-input-number
                          v-model="lstMaterial[index].actualImport"
                          @keydown="keyProcess"
                          :id="'input_' + index"
                          :data-index="index"
                          style="text-align: center"
                          v-if="roleGroup == 3"
                      />
                      <template v-else>
                        {{ item.actualImport | currency }}
                      </template>
                    </td>
                    <td style="text-align: center" v-if="showImportTotal">{{ item.totalImportQuantity | currency }}</td>
                    <td style="text-align: center">
                      <template v-for="(supplier, i) in lstSupplier">
                        <!-- linhdx truong hop ma chi co 1 id-->
                           <span v-if="supplier.partnerId == item.supplyId" :key="i">
                              {{ supplier.partnerName }}
                           </span>
                        <!--  linhdx sua trong truong hop supplyId dang 75,76-->
                        <div v-if="checkSupplyId(item, supplier.partnerId)" :key="i">
                          <div>{{ supplier.partnerName }}</div>
                        </div>
                      </template>
                    </td>
                    <td style="text-align: center;">
                      <i-datepicker
                          v-if="wkUpdate"
                          v-model="lstMaterial[index].expiryDate"
                          :minDate="minDate()"
                      />
                      <template v-else>
                        {{ dateFormat(item.expiryDate) }}
                      </template>
                    </td>
                    <td v-if="showColKst">
                        <v-textarea
                            v-if="isEditEngineerNote"
                            rows="2"
                            v-model="lstMaterial[index].engineer_note"
                        />
                        <span v-else>{{ lstMaterial[index].engineer_note }}</span>
                    </td>
                    <td v-if="showColBgd">
                        <v-textarea
                            v-if="isEditDirectorNote"
                            rows="2"
                            v-model="lstMaterial[index].director_note"
                        />
                        <span v-else>{{ lstMaterial[index].director_note }}</span>
                    </td>
                  </tr>
                </template>
              </table>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 sm12 md6>
              <div style="padding: 20px 10px" v-if="showColKst">
                <v-textarea
                    v-if="showConfirm || showUpdate"
                    outlined
                    label="Kỹ sư trưởng đánh giá chất lượng"
                    rows="2"
                    v-model="importWh.evalutionEngineer"
                />
                <div v-else>
                  <p class="font-weight-bold">Kỹ sư trưởng đánh giá chất lượng</p>
                  {{ importWh.evalutionEngineer }}
                </div>
              </div>
              <div style="padding: 0px 10px" v-if="showEvalutionDirector">
                <v-textarea
                    v-if="importWh.status == 2"
                    outlined
                    label="Ban giám đốc đánh giá chất lượng"
                    rows="2"
                    v-model="importWh.evalutionDirector"
                />
                <div v-else>
                  <p class="font-weight-bold">Ban giám đốc đánh giá chất lượng</p>
                  {{ importWh.evalutionDirector }}
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn v-if="showViewReturn" color="info" @click="viewReturn" :disabled="loading">
            Phiếu trả hàng
          </v-btn>
          <v-btn color="info" @click="historyDlg=true" v-if="importWh.importId != undefined && importWh.importId != null">
              {{ $t("lang.common.history") }}
          </v-btn>
          <v-btn color="info" @click="onPrint" :disabled="loading">
            {{ $t("lang.common.print") }}
          </v-btn>
          <v-btn v-if="showConfirm" color="success" @click="onConfirm" :disabled="loading">
            {{ $t("lang.common.confirm") }}
          </v-btn>
          <v-btn v-if="showApprove" color="success" @click="onApprove" :disabled="loading">
            {{ $t("lang.common.approve") }}
          </v-btn>
          <v-btn v-if="showReject" color="warning" @click="onReject" :disabled="loading">
            {{ $t("lang.common.notApprove") }}
          </v-btn>
          <v-btn v-if="showUpdate || wkUpdate" color="primary" @click="onSave" :disabled="loading">
            {{ $t("lang.common.update") }}
          </v-btn>
          <v-btn v-if="showReturn" color="warning" @click="onReturn" :disabled="loading">
            {{ $t("Trả lại") }}
          </v-btn>
          <v-btn v-if="showDelete" color="error" @click="onReject" :disabled="loading">
            {{ $t("Hủy phiếu") }}
          </v-btn>
          <v-btn color="default" @click="onCancel">
            {{ $t("lang.common.back") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <v-dialog max-width="400px" v-model="dialogReturn" persistent>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title style="padding-left: 0px">
            Chọn vụ nuôi
          </v-toolbar-title>
        </v-toolbar>
        <v-btn
            @click="closeReturn"
            icon
            style="
                position: absolute;
                right: 10px;
                top: 10px;
                color: #fff;
            "
        >
          <v-icon>cancel</v-icon>
        </v-btn>
        <v-form
          id="formCreateRequest"
          ref="formCreateRequest"
          v-model="validFormCreateRequest"
          lazy-validation
        >
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
                  :items="lstArea"
                  label="Khu nuôi"
                  v-model="areaId"
                  name="areaId"
                  item-value="categoryId"
                  item-text="categoryName"
                  v-validate="'required'"
                  :data-vv-as="$t('Khu nuôi')"
                  :error-messages="errors.first('areaId')"
                  disabled
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="lstCropActive"
                  label="Mã vụ nuôi"
                  v-model="cropId"
                  name="cropId"
                  item-value="cropId"
                  item-text="code"
                  v-validate="'required'"
                  :data-vv-as="$t('Mã vụ nuôi')"
                  :error-messages="errors.first('cropId')"
              />
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveReturn">
            <v-icon dark left>save</v-icon>
            {{ $t("Tạo phiếu") }}
          </v-btn>
          <v-btn color="error" @click="closeReturn">
            <v-icon dark left>cancel</v-icon>
            {{ $t("lang.common.cancel") }}
          </v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="historyDlg" width="800px" persistent>
        <v-form data-vv-name="historyForm">
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">
                        Lịch sử
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="historyDlg=false"
                        icon
                        style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <table class="lstTable" v-if="lstHistory.length>0">
                        <tr>
                            <th width="20%">Thời gian</th>
                            <th width="15%">Người xử lý</th>
                            <th width="15%">Xử lý</th>
                            <th width="50%">Nội dung</th>
                        </tr>
                        <tr v-for="item in lstHistory">
                            <td>{{item.actionTime|formatDateTime}}</td>
                            <td><label style="font-weight: bold;color:blue">{{item.userName}}</label></td>
                            <td>{{item.action}}</td>
                            <td><label v-if="item.actionContent"> {{item.actionContent}}</label></td>
                        </tr>
                    </table>
                    <div v-else style="border:1px solid grey;border-radius: 10px;padding: 10px">Không có lịch sử
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn @click="historyDlg=false">{{$t('lang.common.close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>

    <v-dialog
        v-model="confirmDialog"
        persistent
        max-width="290"
    >
        <v-card>
            <v-card-title class="text-h3">
            Bạn có muốn xác nhận phiếu nhập kho này ?
            </v-card-title>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text  @click="confirmDialog = false">
                Hủy bỏ
            </v-btn>
            <v-btn color="success" text @click="agreeConfirm">
                Đồng ý
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog
        v-model="approveDialog"
        persistent
        max-width="290"
    >
        <v-card>
            <v-card-title class="text-h3">
            Bạn có muốn duyệt phiếu nhập kho này ?
            </v-card-title>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text  @click="approveDialog = false">
                Hủy bỏ
            </v-btn>
            <v-btn color="success" text @click="agreeApprove">
                Đồng ý
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog
        v-model="rejectDialog"
        persistent
        max-width="290"
    >
        <v-card>
            <v-card-title class="text-h3">
            Không phê duyệt phiếu nhập kho này ?
            </v-card-title>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text  @click="rejectDialog = false">
                Hủy bỏ
            </v-btn>
            <v-btn color="success" text @click="agreeReject">
                Đồng ý
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import {message} from "../../../shared/message";
import { requestConstants, roleConstants } from "@/constants";

export default {
  name: "ImportWhView",
  components: {IDatepicker},
  data: () => {
    return {
      formName: "Phiếu nhập kho",
      roleGroup: 1,
      warehouseCode: "",
      importRequestNumber: '',
      lstSupplier: [],
      lstMaterial: [],
      lstMaterialTmp: [],
      lstImportWh: [],
      importRequest: null,
      importWh: {
        status: 0,
        evalutionEngineer: '',
        evalutionDirector: '',
      },
      isEdit: false,
      loading: false,
      dialogReturn: false,
      validFormCreateRequest: true,
      areaId: 0,
      cropId: 0,
      lstArea: [],
      lstCropActive: [],
      historyDlg: false,
      lstHistory: [],
      confirmDialog: false,
      approveDialog: false,
      rejectDialog: false,
    };
  },

  created() {
    // 2: thủ kho;  26: mua hàng
    // const role = parseInt(this.$store.state.auth.user.role);

    this.getImportWh();
    this.getSuppliers();
    this.getPondArea();
  },

  computed: {
    wkUpdate() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER
          && this.importWh.status == requestConstants.importWhStatusCons.waitConfirm) {
        return true;
      } else {
        return false;
      }
    },
    showConfirm() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.importWh.status == requestConstants.importWhStatusCons.waitConfirm) {
        return true;
      } else {
        return false;
      }
    },
    showUpdate() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.importWh.status == requestConstants.importWhStatusCons.waitApprove
          || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          && this.importWh.status == requestConstants.importWhStatusCons.waitApprove
          || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT
          && this.importWh.status == requestConstants.importWhStatusCons.waitApprove) {
        return true;
      } else {
        return false;
      }
    },
    showReturn() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.importWh.status == requestConstants.importWhStatusCons.waitConfirm
          || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.importWh.status == requestConstants.importWhStatusCons.waitApprove
          || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.importWh.status == requestConstants.importWhStatusCons.rejected) {
        return true;
      } else {
        return false;
      }
    },
    showApprove() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          && this.importWh.status == requestConstants.importWhStatusCons.waitApprove) {
        return true;
      } else {
        return false;
      }
    },
    showReject() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          && this.importWh.status == requestConstants.importWhStatusCons.waitApprove) {
        return true;
      } else {
        return false;
      }
    },
    showDelete() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          && this.importWh.status == requestConstants.importWhStatusCons.approved) {
        return true;
      } else {
        return false;
      }
    },
    showEvalutionDirector() {
      if (
          this.importWh.status == requestConstants.importWhStatusCons.waitApprove && this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          || this.importWh.status == requestConstants.importWhStatusCons.approved && this.importWh.evalutionDirector != null
          || this.importWh.status == requestConstants.importWhStatusCons.rejected && this.importWh.evalutionDirector != null
          || this.importWh.status == requestConstants.importWhStatusCons.returned && this.importWh.evalutionDirector != null
          )
      {
        return true;
      } else {
        return false;
      }
    },
    showColKst() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER
          && this.importWh.status == requestConstants.importWhStatusCons.waitConfirm
          ) {
        return false;
      } else {
        return true;
      }
    },
    showColBgd() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          || this.importWh.status == requestConstants.importWhStatusCons.approved
          || this.importWh.status == requestConstants.importWhStatusCons.rejected
          || this.importWh.status == requestConstants.importWhStatusCons.returned && this.importWh.isReject == 1
          ) {
        return true;
      } else {
        return false;
      }
    },
    isEditEngineerNote() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER && this.importWh.status == requestConstants.importWhStatusCons.waitConfirm
          || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER && this.importWh.status == requestConstants.importWhStatusCons.waitApprove
          ) {
        return true;
      } else {
        return false;
      }
    },
    isEditDirectorNote() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR && this.importWh.status == requestConstants.importWhStatusCons.waitApprove) {
        return true;
      } else {
        return false;
      }
    },
    showImportTotal() {
      return true;
      // if (this.$store.state.auth.user.role != roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER) {
      //   return true;
      // } else {
      //   return false;
      // }
    },
    showViewReturn() {
      if (this.importWh.status == requestConstants.importWhStatusCons.returned) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    onCancel() {
      let queryParam = this.$route.query;
      if (queryParam.searchImportRequest != undefined) {
        this.$router.push({ path: '/importRequest', query: this.$route.query });
      } else {
        this.$router.push({path: '/importRequest/view/' + this.$route.params.id, query: this.$route.query});
      }
    },
    onCancelAfterUpdate() {
      this.$router.push({ path: '/importRequest', query: this.$route.query });
      //this.$router.push({path: '/importRequest'});
    },
    onEdit() {
      this.isEdit = true;
    },
    onSave() {

      const lstMaterial_tmp = this.lstMaterial;
      let importSuccess = 1;
      let incomplete = 0;
      let rt = true;
      let supplyId = '';

      $.each(lstMaterial_tmp, function (k, v) {
        if (k == 0) {
            supplyId += lstMaterial_tmp[k].supplyId;
        } else {
            supplyId += ',' + lstMaterial_tmp[k].supplyId;
        }
      //   lstMaterial_tmp[k].changeQuantity = v.actualImport - v.actualImportOld;

      //   const totalImport = parseFloat(v.actualImport) + parseFloat(v.totalImportQuantity);
      //   // console.log(v.buyNumberPropose, totalImport);
      //   if (v.buyNumberPropose != totalImport) {
      //       importSuccess = 0;
      //       if (v.buyNumberPropose < totalImport) {
      //           incomplete = 1
      //       } else if (v.buyNumberPropose > totalImport) {
      //           incomplete = 2
      //       }
      //   }
      });

      const createItem = this.importWh;
      createItem.supplyId = supplyId;
      // createItem.importSuccess = importSuccess;
      // createItem.incomplete = incomplete;
      createItem.requestData = JSON.stringify(lstMaterial_tmp);
      // return;
      this.loading = true;
      axios
          .post(process.env.VUE_APP_API_URL + "/importWh/save", createItem)
          .then(
              (data) => {
                if (data.success) {
                  message.success(
                      this.$t("lang.common.save_success")
                  );
                  this.onCancelAfterUpdate();
                } else {
                  message.error(this.$t(data.description));
                }
                this.loading = false;
                this.isEdit = false;
              },
              (error) => {
                this.loading = false;
                this.isEdit = false;
                console.log(error);
              }
          );
    },

    onPrint() {
      axios({
        url: process.env.VUE_APP_API_URL + "/importWh/exportExcelImportWh",
        method: "POST",
        data: this.importWh,
        responseType: "blob", // important
      }).then(response => {
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Phieu_nhap_kho" + ".xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      });
    },
    agreeConfirm() {
      this.importWh.status = requestConstants.importWhStatusCons.waitApprove;
      this.onSave();
    },
    onConfirm() {
      this.confirmDialog = true;
    },
    agreeApprove() {
      this.importWh.status = requestConstants.importWhStatusCons.approved;
      this.onSave();
    },
    onApprove() {
      this.approveDialog = true;
    },
    onReject() {
      this.rejectDialog = true;
    },
    agreeReject() {
      this.loading = true;
      axios
          .post(process.env.VUE_APP_API_URL + "/importWh/reject", {importId: this.importWh.importId})
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  this.onCancel();
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },
    onReturn() {
      this.dialogReturn = true;
    },
    viewReturn() {
      this.loading = true;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/search?pageSize=-1&page=-1", {importWhId: this.importWh.importId})
          .then(
              (data) => {
                  if (data.items && data.items[0] != undefined) {
                      let route = this.$router.resolve({path: '/exportRequest/NotProcessView/' + data.items[0].exportId});
                      window.open(route.href, '_blank');
                  }
                  this.loading = false;
              },
              (error) => {
                  this.loading = false;
                  console.log(error);
              }
          );
    },
    getImportWh() {
      let queryParam = this.$route.query;
      let action = "getByImportRequestId";
      if (queryParam.searchByImportWhId != undefined) {
        action = "detail";
      }

      axios.post(
          process.env.VUE_APP_API_URL + "/importWh/" + action + "/" + this.$route.params.id
      )
          .then((data) => {
            if (data) {
              console.log(data);
              if (action == "detail") {
                this.importWh = data;
              } else {
                this.importWh = data[0];
              }
              
              this.areaId = this.importWh.areaId;
              this.lstMaterial = JSON.parse(this.importWh.requestData);
              if (this.importWh.reqOrdId != null && this.importWh.reqOrdId > 0) {
                  this.getImportRequest(this.importWh.importRequestId);
              }
              this.getWarehouses(this.importWh.warehouseId);
              this.getCropActive(this.importWh.areaId);
              if (this.importWh.reqOrdId != null && this.importWh.reqOrdId > 0) {
                  this.getListImportWh(this.importWh.reqOrdId);
              }
              this.getHistory(this.importWh);
            }
          });
    },
    getImportRequest(id) {
      if (id) {
        axios
            .post(
                process.env.VUE_APP_API_URL + "/importRequest/detail/" + id
            )
            .then((data) => {
              if (typeof data == "object") {
                this.importRequestNumber = data.requestNumber;
              }
            });
      }
    },
    getWarehouses(categoryId) {
      axios
          .post(
              process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?pageSize=-1&page=-1&categoryTypeCode=WAREHOUSE",
              {categoryId}
          )
          .then((data) => {
            if (data.items != undefined && data.items.length > 0) {
              this.warehouseCode = data.items[0].categoryName;
            }
          });
    },
    getSuppliers() {
      axios.post(
          process.env.VUE_APP_API_URL + "/partner/suppliers?pageSize=-1&page=-1",
          {status: 1}
      )
          .then((data) => {
            if (data.items) {
              this.lstSupplier = data.items;
            }
          });
    },
    keyProcess($event) {
      let index = parseInt($event.target.getAttribute("data-index"));
      let input_id = '';
      switch ($event.keyCode) {
        case 13:
          index += 1;
          input_id = "input_" + index;
          var element = document.getElementById(input_id);
          if (typeof element != "undefined" && element != null) {
            element.focus();
          } else {
            $event.target.blur();
          }
          $event.preventDefault();
          break;
        case 38:
          // up
          if (index > 0) {
            index -= 1;
            input_id = "input_" + index;
            var element = document.getElementById(input_id);
            if (typeof element != "undefined" && element != null) {
              element.focus();
            }
          }
          $event.preventDefault();
          break;
        case 40:
          //down
          index += 1;
          input_id = "input_" + index;
          var element = document.getElementById(input_id);
          if (typeof element != "undefined" && element != null) {
            element.focus();
          }
          $event.preventDefault();
          break;
      }
    },
    minDate() {
      const minDate = moment().format('YYYY-MM-DD');
      return minDate;
    },
    dateFormat(date) {
      let d = '';
      if (date != '' && date != null && date != undefined) {
        d = moment(String(date)).format('DD-MM-YYYY');
      }
      return d;
    },
    setLstMaterial() {
      const self = this;
      const lstMaterial_tmp = this.lstMaterial;
      const lstImportWh = this.lstImportWh;
      console.log(lstMaterial_tmp);
      $.each(lstMaterial_tmp, function (k, v) {
        lstMaterial_tmp[k].actualImportOld = v.actualImport;

        // thực nhập lũy kế
        // if (self.showImportTotal) {
        //   let totalImport = 0; 
        //   $.each(lstImportWh, function (k2, v2) {
        //       const requestData = JSON.parse(v2.requestData);
        //       const mate = requestData.find(function (o) {
        //           return o.materialId == v.materialId;
        //       });
        //       if (mate != undefined) {
        //           totalImport += parseFloat(mate.actualImport);
        //       }
        //   });
        //   lstMaterial_tmp[k].totalImportQuantity = totalImport;
        // }
      });
      this.lstMaterial = lstMaterial_tmp;
    },
    checkSupplyId(item, partnerId) {
      let check = false;
      if (item.supplyId != undefined 
        && (item.supplyId.toString().indexOf(partnerId+',') != -1
            || item.supplyId.toString().indexOf(',' + partnerId) != -1)) {
        check = true;
      }
      return check;
    },
    closeReturn() {
      this.dialogReturn = false;
    },
    saveReturn() {
        if (!(this.cropId > 0)) {
            message.error('Chưa chọn vụ nuôi');
            return;
        }
        this.dialogReturn = false;

        const query = this.$route.query;
        query.importId = this.importWh.importId;

        this.$router.push({path: '/exportRequest/notProcessCreate/' + this.cropId + '/type/2', query: query});
    },
    getPondArea() {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/myArea"
      )
          .then((data) => {
            if (data.length > 0) {
              this.lstArea = data;
            }
          });
    },
    getCropActive(areaId) {
      const search = {status: 1};
      if (areaId > 0) search.pondAreaId = areaId;
      axios.post(
          process.env.VUE_APP_API_URL + "/crop/search?sortField=code&pageSize=-1&page=-1&orderBy=desc", search
      )
          .then(
              (data) => {
                if (data.items) {
                  this.lstCropActive = data.items;
                }
              }
          );
    },
    getListImportWh(reqOrdId) {
        axios.post(
                process.env.VUE_APP_API_URL + "/importWh/search?pageSize=-1&page=-1",
                { reqOrdId: reqOrdId }
            )
            .then((data) => {
                if (data.items) {
                    this.lstImportWh = data.items;
                    this.setLstMaterial();
                }
            });
    },
    getHistory(importWh) {
      axios.post(
          process.env.VUE_APP_API_URL + "/importWh/searchHistory?importId=" + importWh.importId).then(
          (data) => {
            this.lstHistory = data;
          }
      );
    },
  },

  destroyed() {
  },
};
</script>
